import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaBell,
  FaStar,
  FaUsers,
  FaImages,
} from "react-icons/fa";

// Replace with your deployed Google Apps Script URL
const SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbybbQV9I8isyNYwi9NT1zQLm8Fts9sDAWGvEW7Prq1V4rUnC6XXJzLd2Kr-HMiTGW2t/exec";

function AdminDashboard() {
  const [reviewsCount, setReviewsCount] = useState(0);
  const [notificationsCount, setNotificationsCount] = useState(0);
  const [totalVisitors, setTotalVisitors] = useState(0);

  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${SCRIPT_URL}?type=reviews`)
      .then((res) => res.json())
      .then((data) => setReviewsCount(data.count || 0))
      .catch((err) => console.error(err));

    fetch(`${SCRIPT_URL}?type=notifications`)
      .then((res) => res.json())
      .then((data) => setNotificationsCount(data.count || 0))
      .catch((err) => console.error(err));

    fetch(`${SCRIPT_URL}?type=logVisitor`)
      .then((res) => res.json())
      .then((data) => setTotalVisitors(data.count || 0))
      .catch((err) => console.error(err));
  }, []);

  return (
   <div
  style={{
    padding: "40px 65px",
    paddingTop: "180px",   // <-- enough space for fixed header
    minHeight: "100vh",
    background: "#f7fafc",
  }}
>
      <h1
        style={{
          textAlign: "center",
          fontSize: "42px",
          color: "#2d3748",
          marginBottom: "40px",
          fontWeight: "700",
        }}
      >
        Welcome to Admin Dashboard
      </h1>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit,minmax(240px,1fr))",
          gap: "25px",
        }}
      >
        <div
          style={cardStyle("#E0F7FA")}
          onClick={() => navigate("/notifications")}
        >
          <div style={iconCircle("#00ACC1")}>
            <FaBell size={30} color="white" />
          </div>

          <h3>Notifications</h3>

          <h2>{notificationsCount}</h2>
        </div>

        <div
          style={cardStyle("#FFE5EC")}
          onClick={() => navigate("/view-reviews")}
        >
          <div style={iconCircle("#E91E63")}>
            <FaStar size={30} color="white" />
          </div>

          <h3
  style={{
    textAlign: "center",
    width: "100%",
    margin: "0",
  }}
>
  Reviews
</h3>

          <h2>{reviewsCount}</h2>
        </div>

        <div style={cardStyle("#E8F5E9")}>
          <div style={iconCircle("#43A047")}>
            <FaUsers size={30} color="white" />
          </div>

          <h3>Total Visitors</h3>

          <h2>{totalVisitors}</h2>
        </div>

        <div
          style={cardStyle("#FFF8E1")}
          onClick={() => navigate("/admin-gallery")}
        >
          <div style={iconCircle("#F9A825")}>
            <FaImages size={30} color="white" />
          </div>

          <h3>Gallery</h3>
        </div>
      </div>
    </div>
  );
}

const cardStyle = (bg) => ({
  background: bg,
  borderRadius: "22px",
  padding: "28px",
  textAlign: "center",
  cursor: "pointer",
  transition: "0.3s",
  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "12px",
  minHeight: "220px",
  color: "#2d3748",
});

const iconCircle = (color) => ({
  width: "70px",
  height: "70px",
  borderRadius: "50%",
  background: color,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0 8px 20px rgba(0,0,0,.12)",
});

export default AdminDashboard;